import React from 'react';
import { useTranslation } from 'next-i18next';

const NegotiationListingsRespondButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useTranslation('negotiation');

  return (
    <button
      className="vc-btn vc-btn--rounded-secondary vc-btn--small"
      onClick={onClick}
      data-cy="negotiation_pages_cta_respond"
    >
      {t('NEGOTIATION_LISTING.OFFERS_SHARED.CTA.RESPOND')}
    </button>
  );
};

export default NegotiationListingsRespondButton;
